import type { ReactNode } from "react";

import { type SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";

import styles from "./Count.module.scss";

export type CountProps = {
  value: ReactNode;
} & SafeHtmlAttributes<HTMLSpanElement>;

export const Count = ({ value, ...rest }: CountProps) => (
  <span className={styles.count} {...rest}>
    {value}
  </span>
);
